var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigdata(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "143.049 195.793 60.9 51",
    width: 60.9,
    height: 51,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.015, 0, 0, 0.85, 143.048767, 195.79303)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59,14h-3v-4c0-0.6-0.4-1-1-1H28V1c0-0.6-0.4-1-1-1H1C0.4,0,0,0.4,0,1v59h2V2h24v8v4H8v2h19h28h3v44h2V15 C60,14.4,59.6,14,59,14z M28,14v-3h26v3H28z",
    style: {
      fill: "rgb(3, 127, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,39c-1.9,0-3.4,1.3-3.9,3H42V26.9c1.7-0.4,3-2,3-3.9c0-2.2-1.8-4-4-4s-4,1.8-4,4c0,1.9,1.3,3.4,3,3.9V42h-9v-7.1 c1.7-0.4,3-2,3-3.9c0-2.2-1.8-4-4-4s-4,1.8-4,4c0,1.9,1.3,3.4,3,3.9V50H18V36.9c1.7-0.4,3-2,3-3.9c0-2.2-1.8-4-4-4s-4,1.8-4,4 c0,1.9,1.3,3.4,3,3.9V50h-3.1c-0.4-1.7-2-3-3.9-3c-2.2,0-4,1.8-4,4s1.8,4,4,4c1.9,0,3.4-1.3,3.9-3H29v8h2V44h16.1 c0.4,1.7,2,3,3.9,3c2.2,0,4-1.8,4-4S53.2,39,51,39z M39,23c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S39,24.1,39,23z M15,33 c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S15,34.1,15,33z M9,53c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S10.1,53,9,53z M28,31 c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S28,32.1,28,31z M51,45c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S52.1,45,51,45z",
    style: {
      fill: "rgb(3, 127, 255)"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigdata);
export default __webpack_public_path__ + "static/media/bigdata.98f7995a1cc6dec26e1dde9367f4ed5d.svg";
export { ForwardRef as ReactComponent };